export default "__VITE_ASSET__CXIykjz5__"